import React from "react";
import { createPortal } from "react-dom";

import { cn } from "lib/utils";

import { MegaMenuPanel } from "./MegaMenuPanel";
import type { MegaMenuCategoryConfig, MegaMenuPanelLabels } from "./types";
import { useHoverDropdown } from "./useHoverDropdown";

interface MegaMenuHoverAnchorProps {
    trigger: React.ReactNode | ((state: { open: boolean }) => React.ReactNode);
    categories: MegaMenuCategoryConfig[];
    labels: MegaMenuPanelLabels;
    panelWidth?: number;
    className?: string;
}

export const MegaMenuHoverAnchor: React.FC<MegaMenuHoverAnchorProps> = ({
    trigger,
    categories,
    labels,
    panelWidth,
    className,
}) => {
    const { open, position, anchorRef, panelRef, close, hoverHandlers, focusHandlers, handleKeyDown } = useHoverDropdown({
        panelWidth,
    });
    const triggerContent = typeof trigger === "function" ? trigger({ open }) : trigger;

    return (
        <>
            <div
                ref={anchorRef}
                className={cn("flex items-center self-stretch", className)}
                {...hoverHandlers}
                {...focusHandlers}
                onKeyDown={handleKeyDown}
            >
                {triggerContent}
            </div>

            {open &&
                createPortal(
                    <div
                        ref={panelRef}
                        className="pt-1"
                        style={{
                            position: "fixed",
                            top: position.top,
                            left: position.left,
                            zIndex: 9999,
                        }}
                        {...hoverHandlers}
                        {...focusHandlers}
                        onKeyDown={handleKeyDown}
                    >
                        <MegaMenuPanel categories={categories} labels={labels} onNavigate={close} />
                    </div>,
                    document.body,
                )}
        </>
    );
};
